<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex col-sm-6 padding-left-0">
        <div class="col-sm-6 padding-left-0">
          <multiselect v-model="report" :max-height="200"
                       placeholder="" label="report_name" track-by="report_name"
                       :options="packets_reports" :multiple="false"
                       :close-on-select="true" @select="applyPacketsReport"
                       select-label="" deselect-label="" selected-label=""
          ></multiselect>
        </div>
        <history-packet-modal></history-packet-modal>
        <div class="button-group d-flex col-sm-6">
          <b-btn size="sm" title="Create new report" style="margin-left: 0" :disabled="!packets.length"
                 @click="createPacketsReport">
            {{$t('buttons.common.create')}}
          </b-btn>
          <b-btn size="sm" title="Delete selected report" variant="outline-danger" :disabled="!report"
                 @click="deleteSelectedReport">
            {{$t('buttons.common.delete')}}
          </b-btn>
          <b-btn size="sm" title="Update selected report" variant="outline-success" :disabled="!report"
                 @click="updateSelectedReport">
            {{$t('buttons.common.update')}}
          </b-btn>
        </div>
      </div>
      <div class="d-flex justify-content-end col-sm-6 padding-0">
        <div class="col-sm-6">
          <multiselect v-model="excelReport" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="manufacture_exports" :multiple="false"
                       :close-on-select="true" @select="selectManufactureReport"
                       select-label="" deselect-label="" selected-label=""
          ></multiselect>
        </div>
        <div class="button-group padding-right-0">
          <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
               :title="$t('buttons.common.clear_filters')">
          <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
               :title="$t('buttons.common.search')">
        </div>
      </div>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.common.period_of_time')}}</label>
            <multiselect v-model="searchData.period" :max-height="200" :searchable="true"
                         placeholder=""
                         label="name" track-by="name"
                         :options="periods"
                         @select="selectPeriod"
                         select-label="" deselect-label="" selected-label=""
            ></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.start_date')}}</label>
            <datepicker v-model="searchData.start_date" lang="en"
                        placeholder=""
                        :width="170"
                        :first-day-of-week="1"
            ></datepicker>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.end_date')}}</label>
            <datepicker v-model="searchData.end_date" lang="en"
                        placeholder=""
                        :width="170"
                        :first-day-of-week="1"
            ></datepicker>
          </b-col>
          <b-col>
            <label>{{$t('labels.operations.operation_type')}}</label>
            <multiselect v-model="searchData.processes" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="processes" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
             :aria-expanded="showCollapse  ? 'true' : 'false'"
             aria-controls="collapse">
          <h3>
            {{$t('common_content.advanced_search')}}
          </h3>
          <div class="icons-wrapper">
            <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
            <icon name="angle-right" class="angle" v-else></icon>
          </div>
        </div>
        <b-collapse id="collapse" v-model="showCollapse">
          <b-row>
            <b-col>
              <label>{{$t('labels.common.group')}}</label>
              <multiselect v-model="searchData.group" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="groups" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""
              ></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.thickness')}}</label>
              <multiselect v-model="searchData.thickness" :max-height="200"
                           placeholder=""
                           :options="packages_thicknesses" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.package_nr')}}</label>
              <input class="form-control" v-model="searchData.package_nr"
                     @keyup.enter="search">
            </b-col>
            <b-col>
              <label>{{$t('labels.common.supplier')}}/{{$t('labels.common.buyer')}}</label>
              <multiselect v-model="searchData.partners" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="partners" :multiple="true"
                           :options-limit="partners.length"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.common.wood')}}</label>
              <multiselect v-model="searchData.tree" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="wood" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.width')}}</label>
              <multiselect v-model="searchData.width" :max-height="200"
                           placeholder=""
                           :options="packages_widths" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.delivery_address')}}</label>
              <multiselect v-model="searchData.delivery_addresses" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="delivery_addresses" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.production_place')}}</label>
              <multiselect v-model="searchData.production_places" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="production_places" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""
              ></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.common.quality')}}</label>
              <multiselect v-model="searchData.quality" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="qualities_list" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.length')}}</label>
              <multiselect v-model="searchData.length" :max-height="200"
                           placeholder=""
                           :options="packages_lengths" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.stock')}}</label>
              <multiselect v-model="searchData.stock_addresses" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="stock_addresses" :multiple="true" :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""
              ></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.executor')}}</label>
              <multiselect v-model="searchData.user" :max-height="200"
                           placeholder="" label="username" track-by="id"
                           :options="users" :multiple="true" :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""
              ></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.common.profile')}}</label>
              <multiselect v-model="searchData.profile" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="profiles" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col cols="3">
              <label>{{$t('labels.common.locating_in_operation')}}</label>
              <multiselect v-model="searchData.operationType" :max-height="200"
                           placeholder="" label="name" track-by="name"
                           :options="operationTypes" :multiple="false"
                           :close-on-select="true" :allowEmpty="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.certificate')}}</label>
              <multiselect v-model="searchData.wood_certificate" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="wood_certificates" :multiple="true" :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""
              ></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.locating')}}</label>
              <multiselect v-model="searchData.locations" :max-height="200"
                           placeholder="" label="name" track-by="name"
                           :options="locations" :multiple="true"
                           :close-on-select="false" :allow-empty="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label>{{$t('labels.common.impr')}}</label>
              <multiselect v-model="searchData.impr" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="imprs" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col cols="3">
              <label>{{$t('labels.common.humidity')}}</label>
              <multiselect v-model="searchData.humidity" :max-height="200"
                           placeholder=""
                           :options="humidity_list" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
    </div>
    <div>
      <b-row>
        <b-col class="d-flex justify-content-start">
                    <span v-for="item in totalData" :key="item.text" class="total-info__item">
                        {{$t(`labels.common.${item.label}`)}}: {{item.value.toLocaleString('ru-RU')}}
                    </span>
        </b-col>
        <b-col class="d-flex justify-content-end">
                    <span v-for="item in selectedData" :key="item.text" class="selected-info__item">
                        {{$t(`labels.common.${item.label}`)}}: {{item.value.toLocaleString('ru-RU')}}
                    </span>
        </b-col>
      </b-row>
    </div>
    <div>
      <package-modal></package-modal>
      <b-row>
        <b-col>
          <ag-grid-vue class="ag-theme-balham" :gridOptions="gridOptions"
                       :style="gridHeight" :rowData="packets" :columnDefs="columns"
                       @selectionChanged="selectionChangedOperations"
                       :filterModified="filterModified" @rowDoubleClicked="openHistoryPacketDialog"
                       :getContextMenuItems="getContextMenuItems" :postProcessPopup="postProcessPopup">
          </ag-grid-vue>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { AgGridVue } from 'ag-grid-vue';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import HistoryPacketModal from '@/components/modals/HistoryPacketModal';
  import PackageModal from '@/components/modals/PackageModal';
  import moment from 'moment';

  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    handlerResponse,
    setNotifyData,
    sumTotalData,
    getFilteredNodes
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import exportExcel from '@/helpers/export-excel-helper';
  import { gridMixins } from '@/mixins';
  import { DATE_FORMAT } from '@/constants';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      AgGridVue,
      Datepicker,
      HistoryPacketModal,
      PackageModal
    },
    data() {
      return {
        showCollapse: false,
        report: null,
        excelReport: null,
        operationTypes: [
          {name: this.$i18n.t('selects.to_stock'), key: 'i'},
          {name: this.$i18n.t('selects.from_stock'), key: 'o'},
          {name: `${this.$i18n.t('selects.from_stock')} / ${this.$i18n.t('selects.to_stock')}`, key: 'io'}
        ],
        locations: [
          {name: this.$i18n.t('selects.stock'), value: 'STOCK'},
          {name: this.$i18n.t('selects.production'), value: 'MOVE'},
          {name: this.$i18n.t('selects.shipped'), value: 'CLOSE'}
        ],
        selectedData: [
          {
            label: 'selected_packets',
            value: 0
          },
          {
            label: 'amount',
            value: 0,
            key: 'amount'
          },
          {
            label: 'm',
            value: 0,
            key: 'm'
          },
          {
            label: 'm2',
            value: 0,
            key: 'm2'
          },
          {
            label: 'm3',
            value: 0,
            key: 'm3'
          }
        ],
        searchData: {
          period: null,
          group: [],
          tree: [],
          quality: [],
          profile: [],
          name: '',
          package_nr: '',
          impr: [],
          wood_certificate: [],
          delivery_addresses: [],
          stock_addresses: [],
          user: [],
          partners: [],
          processes: [],
          production_places: [],
          operationType: {name: this.$i18n.t('selects.to_stock'), key: 'i'},
          start_date: null,
          end_date: null,
          locations: [
            {name: this.$i18n.t('selects.stock'), value: 'STOCK'},
            {name: this.$i18n.t('selects.production'), value: 'MOVE'},
            {name: this.$i18n.t('selects.shipped'), value: 'CLOSE'}
          ],
          length: [],
          width: [],
          thickness: [],
          amount: [],
          humidity: [],
          storageKey: 'reports'
        },
      }
    },
    methods: {
      cleanFilters() {
        cleanFilters(this.searchData, this.storageKey);
        this.setDefaultFilters();
        saveFilters(this.storageKey, this.searchData);
      },
      search() {
        const isShipped = this.searchData.locations.find(item => item.value === 'CLOSE');
        if ((isShipped && this.searchData.start_date) || !isShipped) {
          const searchData = this.prepareSearchData();
          this.$store.dispatch('packets/loadPackets', searchData).then(() => {
            if (this.report) {
              this.gridOptions.columnApi.setColumnState(this.report.grid_state);
              this.gridOptions.api.setFilterModel(this.report.grid_filters);
              this.gridOptions.columnApi.setPivotMode(this.report.is_pivot);
            }
            this.selectedData = sumTotalData([], this.selectedData);
            saveFilters(this.storageKey, this.searchData);
          });
        } else {
          const filters = [this.$i18n.t('labels.common.start_date')];
          this.$swal.fire('', this.$i18n.t(`alerts.much_date`, {filters}), 'warning');
        }
      },
      prepareSearchData() {
        const searchData = {
          condition: 'additional',
          group: getArrayByProperty(this.searchData.group, 'id').toString(),
          tree: getArrayByProperty(this.searchData.tree, 'id').toString(),
          quality: getArrayByProperty(this.searchData.quality, 'id').toString(),
          profile: getArrayByProperty(this.searchData.profile, 'id').toString(),
          package_nr: this.searchData.package_nr,
          impr: getArrayByProperty(this.searchData.impr, 'id').toString(),
          wood_certificate: getArrayByProperty(this.searchData.wood_certificate, 'id').toString(),
          delivery_addresses: getArrayByProperty(this.searchData.delivery_addresses, 'id').toString(),
          stock_addresses: getArrayByProperty(this.searchData.stock_addresses, 'id').toString(),
          width: this.searchData.width.toString(),
          thickness: this.searchData.thickness.toString(),
          length: this.searchData.length.toString(),
          amount: getArrayByProperty(this.searchData.amount, 'amount').toString(),
          humidity: this.searchData.humidity.toString()
        };
        if (!this.isOperationDate) {
          searchData.packets_date_between_after = this.searchData.start_date ? moment(this.searchData.start_date).format(DATE_FORMAT) : '';
          searchData.packets_date_between_before = this.searchData.end_date ? moment(this.searchData.end_date).format(DATE_FORMAT) : '';
        }
        searchData.process_type_access = this.generateProcessTypeAccessField();
        return searchData;
      },
      generateProcessTypeAccessField() {
        return `${this.searchData.operationType.key}, [${getArrayByProperty(this.searchData.processes, 'id')}], ` +
          `[${this.searchData.start_date && this.isOperationDate ? moment(this.searchData.start_date).format(DATE_FORMAT) : ''}], ` +
          `[${this.searchData.end_date && this.isOperationDate ? moment(this.searchData.end_date).format(DATE_FORMAT) : ''}], ` +
          `[${getArrayByProperty(this.searchData.production_places, 'id')}], ` +
          `[${getArrayByProperty(this.searchData.user, 'id')}], [${getArrayByProperty(this.searchData.partners, 'id')}], [${getArrayByProperty(this.searchData.locations, 'value')}]`;
      },
      selectionChangedOperations() {
        const selectedPackets = this.gridOptions.api.getSelectedRows();
        this.selectedData = sumTotalData(selectedPackets, this.selectedData);
      },
      filterModified() {
        const filteredData = getFilteredNodes(this.gridOptions).map(item => item.data);
        this.$store.commit('packets/setTotalData', filteredData);
        this.gridOptions.api.deselectAll();
      },
      selectPeriod(currentPeriod) {
        this.searchData.start_date = currentPeriod.date_start;
        this.searchData.end_date = currentPeriod.date_end;
      },
      openPackageModal(data) {
        this.$root.$emit('openPackageModal', data);
      },
      fetchPackageInfo(packageId) {
        this.$http.get(`woodware/movement_data/${packageId}/`).then(handlerResponse).then(response => {
          const data = {
            editable: false,
            ...response
          };
          this.openPackageModal(data);
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      getContextMenuItems(params) {
        const node = params.node;
        let menuItems = ['autoSizeAll', 'copy', 'export'];
        if (node && node.data) {
          const packageNumber = node.data.package_nr;
          const subpackageMenuItem = {
            name: `Show information of package with № ${packageNumber}`,
            disabled: node.group,
            action: () => {
              const packageId = node.data.id;
              this.fetchPackageInfo(packageId);
            }
          };
          menuItems = [subpackageMenuItem, ...menuItems];
        }

        return menuItems;
      },
      openHistoryPacketDialog(rowData) {
        if (rowData.data) {
          if (rowData.data.package_nr) {
            this.$root.$emit('openHistoryPacketModal', rowData);
          } else {
            this.$swal.fire('', this.$i18n.t(`alerts.not_generated_package_nr`), 'info');
          }
        } else {
          this.$swal.fire('', this.$i18n.t(`alerts.showing_package_history`), 'warning');
        }
      },
      checkValidationToReport(requiredParams) {
        return requiredParams.length === requiredParams.filter(item => this.searchData[item] && this.searchData[item].toString().length).length;
      },
      selectManufactureReport({url, required_params, additional_params}) {
        if (this.checkValidationToReport(required_params)) {
          const searchData = this.prepareSearchData()
          const payload = {
            ...searchData,
            start_date: this.searchData.start_date ? moment(this.searchData.start_date).format(DATE_FORMAT) : '',
            end_date: this.searchData.end_date ? moment(this.searchData.end_date).format(DATE_FORMAT) : '',
            stock_addresses: getArrayByProperty(this.searchData.stock_addresses, 'id').toString(),
            processes: getArrayByProperty(this.searchData.processes, 'id').toString(),
            partners: getArrayByProperty(this.searchData.partners, 'id'),
            thickness: this.searchData.thickness.toString(),
            width: this.searchData.width.toString(),
            length: this.searchData.length.toString(),
            // process_type_access: this.searchData.operationType.key,
            ...additional_params
          };
          exportExcel(url, payload, 'post');
        } else {
          const requiredFields = required_params.map(item => this.$i18n.t(`labels.common.${item}`));
          this.$swal.fire('', this.$i18n.t(`alerts.generate_excel`, {requiredFields}), 'warning');
        }
      },
      setDefaultFilters() {
        this.searchData.operationType = this.operationTypes.find(item => item.key === 'i');
        this.searchData.locations = [
          {name: this.$i18n.t('selects.stock'), value: 'STOCK'},
          {name: this.$i18n.t('selects.production'), value: 'MOVE'}
        ];
      },
      applyPacketsReport(currentPacketsReport) {
        this.searchData = {...currentPacketsReport.filters};
        this.search(currentPacketsReport);
      },
      prepareDialog(dialogContent) {
        return {
          ...dialogContent,
          cancelButtonText: this.$i18n.t(`buttons.common.cancel`),
          showCancelButton: true
        }
      },
      createPacketsReport() {
        const dialogContent = {
          title: this.$i18n.t(`text_content.creating_report`),
          inputPlaceholder: this.$i18n.t(`placeholders.enter_report_name`),
          input: 'text'
        };
        this.$swal.fire(this.prepareDialog(dialogContent)).then(result => {
          const report_name = result.value;
          if (report_name) {
            const grid_state = this.gridOptions.columnApi.getColumnState(),
              grid_filters = this.gridOptions.api.getFilterModel(), filters = this.searchData,
              is_pivot = this.gridOptions.columnApi.isPivotMode();
            const savedData = {report_name, grid_state, grid_filters, filters, is_pivot};
            this.$http.post(`woodware/movement_data_report/`, savedData).then(handlerResponse).then(response => {
              const report_name = response.report_name;
              this.$notify(setNotifyData(this.$i18n.t(`notifications.common.report_created`, {report_name}), '', 'success'));
              this.$store.dispatch('woodware/loadPacketsReports');
            }).catch(error => notificationsRenderer(error.data, 'error'));
          }
        });
      },
      deleteSelectedReport() {
        const dialogContent = {
          title: this.$i18n.t(`modal_dialogs.sure_attempt`),
          text: this.$i18n.t(`modal_dialogs.can_not_restore`),
          icon: 'warning'
        };
        this.$swal.fire(this.prepareDialog(dialogContent)).then(result => {
          if (result.value) {
            const reportId = this.report.id, report_name = this.report.report_name;
            this.$http.delete(`woodware/movement_data_report/${reportId}/`).then(() => {
              this.report = null;
              this.$store.dispatch('woodware/loadPacketsReports');
              this.$swal.fire('', this.$i18n.t(`notifications.common.report_deleted`, {report_name}), 'success');
            }).catch(error => notificationsRenderer(error.data, 'error'));
          }
        });
      },
      updateSelectedReport() {
        const reportId = this.report.id, report_name = this.report.report_name,
          grid_state = this.gridOptions.columnApi.getColumnState(),
          grid_filters = this.gridOptions.api.getFilterModel(), filters = this.searchData,
          is_pivot = this.gridOptions.columnApi.isPivotMode();
        const savedData = {report_name, grid_state, grid_filters, filters, is_pivot};
        this.$http.put(`woodware/movement_data_report/${reportId}/`, savedData).then(() => {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.report_updated`, {report_name}), '', 'success'));
          this.$store.dispatch('woodware/loadPacketsReports');
        }).catch(error => notificationsRenderer(error.data, 'error'));
      }
    },
    computed: {
      ...mapGetters('woodware', {
        stock_addresses: 'stock_addresses',
        processes: 'processes',
        production_places: 'production_places',
        delivery_addresses: 'delivery_addresses',
        users: 'users',
        partners: 'partners',
        groups: 'groups',
        imprs: 'imprs',
        wood: 'wood',
        qualities_list: 'qualities_list',
        profiles: 'profiles',
        wood_certificates: 'wood_certificates',
        humidity_list: 'humidity_list',
        packages_lengths: 'packages_lengths',
        packages_thicknesses: 'packages_thicknesses',
        packages_widths: 'packages_widths',
        periods: 'periods',
        manufacture_exports: 'manufacture_exports',
        packets_reports: 'packets_reports'
      }),
      ...mapGetters('packets', ['gridOptions', 'packets', 'columns', 'totalData']),
      isOperationDate() {
        return this.searchData.processes &&
          (this.searchData.processes.length || this.searchData.production_places.length || this.searchData.user.length);
      },
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 565px)'} : {height: 'calc(100vh - 260px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: 'calc(100vh - 260px)'};
        }
      }
    },
    beforeMount() {
      this.setDefaultFilters();
      this.$store.cache.dispatch('woodware/getPackagesSizes', 'length');
      this.$store.cache.dispatch('woodware/getPackagesSizes', 'width');
      this.$store.cache.dispatch('woodware/getPackagesSizes', 'thickness');
      this.$store.cache.dispatch('woodware/getPeriods');
      this.$store.cache.dispatch('woodware/getProcesses');
      this.$store.cache.dispatch('woodware/getProductionPlaces');
      this.$store.cache.dispatch('woodware/getUsers');
      this.$store.dispatch('woodware/getDeliveryAddresses');
      this.$store.dispatch('woodware/getPartners', {is_active: true});
      this.$store.cache.dispatch('woodware/getProfiles');
      this.$store.cache.dispatch('woodware/getWood');
      this.$store.cache.dispatch('woodware/getQualitiesList');
      this.$store.cache.dispatch('woodware/getGroupsWithHierarchy');
      this.$store.cache.dispatch('woodware/getImprs');
      this.$store.cache.dispatch('woodware/getWoodCertificates');
      this.$store.cache.dispatch('woodware/loadHumidityList');
      this.$store.cache.dispatch('woodware/loadManufactureExports');
      this.$store.cache.dispatch('woodware/loadPacketsReports');
      this.$store.cache.dispatch('woodware/getStockAddresses');
      if (checkSavedFilterData(this.storageKey)) {
        this.searchData = setFilters(this.storageKey);
      }
    },
    beforeDestroy() {
      const emptyData = {
        data: [],
        used_columns: [],
        grid_name: ''
      }
      this.$store.commit('packets/setData', emptyData);
      this.$store.commit('packets/setTotalData', []);
    }
  }
</script>

<style scoped>
  .toggle-container {
    margin-top: 10px;
  }

  .total-info__item, .selected-info__item {
    font-weight: bold;
    font-size: 13px;
  }

  .total-info__item {
    margin-right: 8px;
    color: red;
  }

  .selected-info__item {
    margin-left: 8px;
  }

  .wrapper {
    padding-top: 22px;
  }

  .wrapper input[type='checkbox'] {
    margin-left: 10px;
    margin-top: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/modules/manufacture/Reports.vue